import React, { useEffect, useState } from "react"
import { defineMessages, injectIntl } from "react-intl"
import Select from "react-select"
import LoadingSpinner from "../common/spinner/loading.component"
import { SelectOption } from "../common/types/select/types"
import IntlProps from "../state/helpers/IntlProps"
import Location from "../state/location/Location"

const locationSelectMessages = defineMessages({
    locationsSelectPlaceholder: {
        id: "common.select.payment_account_select_locations.placeholder",
        defaultMessage: "Select location(s)",
    },
    locationSelectPlaceholder: {
        id: "common.select.payment_account_select_location.placeholder",
        defaultMessage: "Select location",
    },
    locationDisabledBadge: {
        id: "common.select.credit_memo_select_location_disabled.badge",
        defaultMessage: "Disabled",
    },
    locationDeletedBadge: {
        id: "common.select.credit_memo_select_location_deleted.badge",
        defaultMessage: "Deleted",
    },
})

type Props = {
    locations : Location[]
    isLoadingLocations : boolean
    onSelect(selectedLocation : SelectOption<string> | SelectOption<string>[]): void
    selectedLocationIds : SelectOption<string> | SelectOption<string>[]
    multi : boolean
}
const LocationSelect = (props: Props & IntlProps ) => {

    const [options, setOptions] = useState<SelectOption<string>[]>([])

    useEffect(() => {
        if(props.isLoadingLocations) {
            return
        }
        const selectOptions = props.locations.map(generateOptions)
        if(props.multi) {
            selectOptions.push({
                value: "",
                label: props.intl.formatMessage({
                    id:"common.location.select.all_unassigned_options",
                    defaultMessage:"All unassigned locations"
                }),
                isDisabled: false,
            })
        }
        setOptions(selectOptions)
    }, [props.locations, props.isLoadingLocations])

    const generateOptions = (location : Location) => {
        return {
            value: location.getId(),
            label: location.getName(),
            isDisabled: location.isDeleted() || !location.getEnabled(),
        }
    }


    const optionRenderer = (option: SelectOption<string>) => {

        const selectedLocation = props.locations.find(loc => loc.getId() === option.value)

        const badge = selectedLocation?.isDeleted() ?
            (<span className="badge badge-secondary badge-pill ml-2">
                {props.intl.formatMessage(locationSelectMessages.locationDeletedBadge)}
            </span>
            ) :
            !selectedLocation?.getEnabled() && !props.multi ?
                (<span className="badge badge-warning badge-pill ml-2">
                    {props.intl.formatMessage(locationSelectMessages.locationDisabledBadge)}
                </span>
                ) :
                null


        return (
            <div className={option.isDisabled ? "custom-disabled-option" : ""}>
                {option.label}
                {badge}
            </div>
        )
    }

    if(props.isLoadingLocations)  {
        return <LoadingSpinner/>
    }

    return (
        <Select
            name="location-select"
            placeholder={props.multi ? props.intl.formatMessage(locationSelectMessages.locationsSelectPlaceholder) :
                props.intl.formatMessage(locationSelectMessages.locationSelectPlaceholder)}
            searchable={true}
            multi={props.multi}
            options={options}
            clearable={false}
            value={props.selectedLocationIds}
            onChange={(locationIds) => props.onSelect(locationIds)}
            optionRenderer={optionRenderer}
        />
    )
}
export default injectIntl(LocationSelect)


// WEBPACK FOOTER //
// ./src/integration/LocationSelect.tsx